import script from "./ColorPalette.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPalette.vue?vue&type=script&setup=true&lang=js"

import "./ColorPalette.vue?vue&type=style&index=0&id=e449860e&scoped=true&lang=scss"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e449860e"]])

export default __exports__